import { render, staticRenderFns } from "./AttestatoForm.vue?vue&type=template&id=10ee8aa4&"
import script from "./AttestatoForm.vue?vue&type=script&lang=js&"
export * from "./AttestatoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports